import axios from "axios";

export default axios.create({
    baseURL: "https://mv-api-dev.ryesgade52.dk",
    headers: {
        "Content-type": "application/json"
    }
});